const interactiveTarget = [
  'button',
  'a[href]',
  'input',
  'textarea',
  'select',
  'label',
  'summary',
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]:not([role="region"])',
  '[role="button"]',
  '[role="link"]',
  '[role="menuitem"]',
  '[role="option"]',
  '[role="combobox"]',
  '[role="checkbox"]',
  '[role="radio"]',
  '[role="switch"]',
  '[role="slider"]',
  '[role="tab"]',
  'audio[controls]',
  'video[controls]',
].join(',');

/**
 * Identifies explicit controls, including nested icons, while excluding passive scroll regions.
 * @param target - Native interaction target.
 * @returns Whether an element or its ancestor owns an interactive action.
 */
export const isInteractiveTarget = (target: EventTarget | null): boolean =>
  target instanceof Element && Boolean(target.closest(interactiveTarget));
